import React from 'react';
import PropTypes from 'prop-types';
import { SplitButton, MenuItem } from 'react-bootstrap';

const SplitButtonDropdowns = ({ ...props }) => {
  const { label, className, menuItems, onClick } = props;

  return (
    <div className='split-button-wrapper'>
      <SplitButton
        title={label}
        id={`split-button-basic ${className}`}
        className={`split-button-default ${className}`}
        onClick={onClick}
      >
        {menuItems.length
          ? menuItems.map((menuItem, index) => {
            return (
              <MenuItem
                key={index}
                eventKey={index}
                onClick={menuItem.onClick}
              >
                {menuItem.label}
              </MenuItem>
            );
          })
          : 'No item'}
      </SplitButton>
    </div>
  );
};

SplitButtonDropdowns.defaultProps = {
  menuItems: [],
  label: 'NEW',
  className: '',
  onClick: () => {}
};

SplitButtonDropdowns.propTypes = {
  menuItems: PropTypes.array,
  className: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func
};

export default SplitButtonDropdowns;



// WEBPACK FOOTER //
// ./src/components/split-button-dropdowns/index.js